import React from 'react';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { useTranslation } from 'react-i18next';

// Per-event "Require guest name and phone" toggle (default ON = original behaviour).
export const GuestDetailsSwitch = ({ checked, onChange, label, hint, testId = 'require-guest-details-switch' }) => (
  <div className="flex items-start justify-between gap-3 rounded-md border border-slate-200 px-3 py-2.5">
    <div>
      <Label className="text-[13px] font-medium">{label}</Label>
      {hint && <p className="text-[11.5px] text-slate-500 mt-0.5">{hint}</p>}
    </div>
    <Switch checked={checked !== false} onCheckedChange={onChange} data-testid={testId} />
  </div>
);

// "Optional details" chip: only for events where guest name/phone is NOT required.
export const OptionalDetailsBadge = ({ sa, testId }) => {
  const { t } = useTranslation();
  if (!sa || sa.require_guest_details !== false) return null;
  return (
    <Badge variant="outline" className="text-[10px] shrink-0 text-violet-700 border-violet-300 bg-violet-50 hover:bg-violet-50"
           data-testid={testId || `optional-details-badge-${sa.id}`}>
      {t('business.optionalDetails')}
    </Badge>
  );
};

// Guest name/phone for transaction rows; '—' when absent, marks Swish-sourced phone.
export const GuestContact = ({ txn, guestLabel = 'Guest', className = 'block text-[10px] text-violet-600 font-medium', testId }) => {
  if (!txn?.is_guest) return null;
  const phone = txn.guest_phone;
  return (
    <span className={className} data-testid={testId}>
      {guestLabel}: {txn.guest_name || '—'} · {phone || '—'}
      {phone && txn.guest_phone_source === 'swish' ? ' (via Swish)' : ''}
    </span>
  );
};
